import css from "./Pictures.module.css";

const BigPicture = ({ alt, description, src, title }) => {
  return (
    <div className={css.big_container}>
      <img className={css.big_img} src={src} alt={alt} />
      <h3 className={css.big_title}>{title?.toUpperCase()}</h3>
      <div className={`${css.big_descripton}`}>{description}</div>
    </div>
  );
};

export default BigPicture;
